type TinyMceInitConfig = Record<string, unknown>;

export const DEFAULT_TINYMCE_CONFIG: TinyMceInitConfig = {
  license_key: "gpl",
  plugins: "code preview wordcount",
  toolbar:
    "undo redo | formatselect | bold italic | alignleft aligncenter alignright | code | preview",
  toolbar_mode: "wrap",
  height: 300,
  menubar: false,
  branding: false,
  entity_encoding: "raw",
  extended_valid_elements: "notranslate",
  custom_elements: "~notranslate",
};

export const initTinyMceWithRetry = ({
  editorId,
  target,
  config = {},
  retryDelayMs = 100,
}: {
  editorId: string;
  target: HTMLTextAreaElement | null;
  config?: TinyMceInitConfig;
  retryDelayMs?: number;
}): (() => void) => {
  if (!target) return () => undefined;

  let isDisposed = false;
  let retryTimeoutId: number | undefined;

  const initEditor = (): void => {
    if (isDisposed) return;

    const tinymce = (window as any).tinymce;
    if (!tinymce) {
      retryTimeoutId = window.setTimeout(initEditor, retryDelayMs);
      return;
    }

    const existing = tinymce.get(editorId);
    if (existing) tinymce.remove(existing);

    tinymce.init({
      target,
      ...DEFAULT_TINYMCE_CONFIG,
      ...config,
    });
  };

  initEditor();

  return () => {
    isDisposed = true;
    if (retryTimeoutId) window.clearTimeout(retryTimeoutId);
  };
};

export const removeTinyMceEditor = (editorId: string): void => {
  const tinymce = (window as any).tinymce;
  if (!tinymce) return;

  const editor = tinymce.get(editorId);
  if (editor) tinymce.remove(editor);
};
